export default {
  GET_MASTER_ORG: {
    url: '/e-general/masterOrg',
    method: 'get',
    isPublic: false
  }
}
